<template>
    <div class="exercises">
        <Navbar />
        <v-container>
            <v-layout row wrap>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-btn slot="activator" color="primary" dark class="mb-2">New Exercise</v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-form v-model="validForm" lazy-validation>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedExercise.name" label="Name" required :rules="nameRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field v-model="editedExercise.login_code" label="Login Code"
                                                required :rules="codeRules"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-menu ref="menuStartDate" :close-on-content-click="false" v-model="menuStartDate"
                                                :nudge-right="40" :return-value.sync="editedExercise.start_date" lazy
                                                transition="scale-transition" offset-y full-width min-width="290px">
                                                <v-text-field slot="activator" v-model="editedExercise.start_date"
                                                    label="Start date" prepend-icon="event" readonly></v-text-field>
                                                <v-date-picker v-model="editedExercise.start_date" no-title scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="menuStartDate = false">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.menuStartDate.save(editedExercise.start_date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-menu ref="menuEndDate" :close-on-content-click="false" v-model="menuEndDate"
                                                :nudge-right="40" :return-value.sync="editedExercise.end_date" lazy
                                                transition="scale-transition" offset-y full-width min-width="290px">
                                                <v-text-field slot="activator" v-model="editedExercise.end_date" label="End date"
                                                    prepend-icon="event" readonly></v-text-field>
                                                <v-date-picker v-model="editedExercise.end_date" no-title scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn flat color="primary" @click="menuEndDate = false">Cancel</v-btn>
                                                    <v-btn flat color="primary" @click="$refs.menuEndDate.save(editedExercise.end_date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                                <v-btn :disabled="!validForm" color="blue darken-1" flat @click.native="save">Save</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>


                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-layout>
            <v-data-table :items="exercises" :headers="headers" class="elevation-1" :search="search" :custom-filter="filterItems"
                :rows-per-page-items='[10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'>
                <template slot="items" slot-scope="props">
                    <td @click="openExercise(props.item)">{{ props.item.name }}</td>
                    <td @click="openExercise(props.item)">{{ props.item.start_date.slice(0,10) }}</td>
                    <td @click="openExercise(props.item)">{{ props.item.end_date.slice(0,10) }}</td>
                    <td class="justify-center layout px-0">
                        <v-icon small class="mr-2" @click="editExercise(props.item)">
                            edit
                        </v-icon>
                        <v-icon small @click="deleteExercise(props.item)">
                            delete
                        </v-icon>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-container>

        <v-snackbar v-model="newExerciseCantCreate" :right="true">
            Exercise can't be created.
            <v-btn color="pink" flat @click="newExerciseCantCreate = false">
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Navbar from '@/components/Navbar.vue'
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        name: 'exercises',
        data() {
            return {
                search: '',
                exercises: [],
                dialog: false,
                menuStartDate: false,
                menuEndDate: false,
                newExerciseCantCreate: false,
                editedIndex: -1,
                headers: [{
                        text: 'Name',
                        align: 'left',
                        value: 'name'
                    },
                    {
                        text: 'Start date',
                        value: 'start_date'
                    },
                    {
                        text: 'End date',
                        value: 'end_date'
                    }
                ],
                editedExercise: {
                    id: '',
                    name: '',
                    login_code: '',
                    start_date: '',
                    end_date: ''
                },
                defaultExercise: {
                    id: '',
                    name: '',
                    login_code: '',
                    start_date: '',
                    end_date: ''
                },
                validForm: false,
                nameRules: [
                    v => !!v || 'Name is required',
                    v => (v && v.length <= 50) || 'Name must be less than 50 characters'
                ],
                codeRules: [
                    v => !!v || 'Login code is required',
                    v => (v && v.length <= 10) || 'Login code must be less than 10 characters'
                ]
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Exercise' : 'Edit Exercise'
            }
        },
        components: {
            Navbar
        },
        methods: {
            filterItems(items, search, filter) {
                if (!search) {
                    return items
                }
                //Split search in array
                let needleAry = search.toString().toLowerCase().split(" ").filter(x => x.trim().length > 0);

                function filterName(item, search) {
                    return item.name != null &&
                        item.name.toLowerCase().includes(search)
                }
                return items.filter(row => needleAry.every(needle => filterName(row, needle)))
            },
            fetchExercises() {
                axios.get('/exercises').then(response => {
                    this.exercises = response.data.reverse()
                }).catch(error => {});
            },
            editExercise(exercise) {
                this.editedIndex = this.exercises.indexOf(exercise)
                this.editedExercise = Object.assign({}, exercise)
                this.handleEditDates()
                this.dialog = true
            },
            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedExercise = Object.assign({}, this.defaultExercise)
                    this.editedIndex = -1
                    this.validForm = false
                    this.menuStartDate = false
                    this.menuEndDate = false
                }, 300)
            },
            save() {
                this.editedExercise.start_date = this.editedExercise.start_date + 'T00:00:00.000Z';
                this.editedExercise.end_date = this.editedExercise.end_date + 'T23:59:59.000Z';
                if (this.editedExercise.id === '') {
                    this.createExercise(this.editedExercise);
                } else {
                    this.updateExercise(this.editedExercise);
                }
                this.close()
            },
            createExercise(exercise) {
                axios.post('/exercises', exercise).then(response => {
                    this.exercises.unshift(response.data)
                }).catch(error => {
                    this.newExerciseCantCreate = true
                });
            },
            updateExercise(exercise) {
                axios.put('/exercises', exercise).then(response => {
                    if (this.editedIndex != -1) {
                        Object.assign(this.exercises[this.editedIndex], this.editedExercise)
                    }
                }).catch(error => {});
            },
            deleteExercise(exercise) {
                if (confirm('Are you sure you want to delete this exercise?')) {
                    axios.delete('/exercises', {
                        data: Object.assign({}, exercise)
                    }).then(response => {
                        this.exercises.splice(this.exercises.indexOf(exercise), 1);
                    }).catch(error => {})
                }

            },
            openExercise(exercise) {
                this.$router.push({
                    name: 'exercise',
                    params: {
                        id: exercise.id
                    }
                })
            },
            handleEditDates() {
                this.editedExercise.start_date = this.editedExercise.start_date.slice(0, 10)
                this.editedExercise.end_date = this.editedExercise.end_date.slice(0, 10)
                if (this.editedExercise.start_date == "0001-01-01") {
                    this.editedExercise.start_date = new Date().toISOString().slice(0, 10)
                }
                if (this.editedExercise.end_date == "0001-01-01") {
                    this.editedExercise.end_date = new Date().toISOString().slice(0, 10)
                }
            }
        },
        mounted() {
            this.fetchExercises();
        }
    }
</script>